// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  HAMBURGER: '[data-fragment="Header.hamburger"]',
  BACKDROP: '[data-fragment="Header.backdrop"]',
};

export default class Header extends WebComponent {
  constructor(props) {
    super(props);

    this.state = {
      menuOpened: false,
      headerScrolled: false,
      headerHidden: false,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
  }

  didMount() {
    this.on('click', fragments.HAMBURGER, this.toggleMenu);
    this.on('click', fragments.BACKDROP, this.closeMenu);
    this.on('click', fragments.BACKDROP, this.closeSearch);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('touchstart', this.handleTouchStart, false);
    document.addEventListener('touchmove', this.handleTouchMove, false);
    this.lastScrollY = 0;
    this.xDown = null;
    this.yDown = null;
  }

  toggleMenu = () => {
    const { menuOpened } = this.state;
    this.setState({
      menuOpened: !menuOpened,
    });
  };

  closeMenu = () => {
    this.setState({
      menuOpened: false,
    });
  };

  handleTouchStart = (e) => {
    const firstTouch = e.touches[0];
    this.xDown = firstTouch.clientX;
    this.yDown = firstTouch.clientY;
  };

  handleTouchMove = (e) => {
    if (!this.xDown || !this.yDown) {
      return;
    }
    const xUp = e.touches[0].clientX;
    const yUp = e.touches[0].clientY;
    const xDiff = this.xDown - xUp;
    const yDiff = this.yDown - yUp;
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        this.closeMenu();
      }
    }
    this.xDown = null;
  };

  handleScroll = () => {
    const scrollY = window.scrollY;
    if (window.scrollY > 100) {
      this.setState({
        headerScrolled: true,
      });
      if (scrollY > this.lastScrollY) {
        this.setState({
          headerHidden: true,
        });
      } else {
        this.setState({
          headerHidden: false,
        });
      }
    } else {
      this.setState({
        headerScrolled: false,
      });
    }
    this.lastScrollY = scrollY <= 0 ? 0 : scrollY;
  };

  handleResize = () => {
    if (window.innerWidth > 1199 && this.state.menuOpened) {
      this.closeMenu();
    }
  };

  willUnMount() {}
  update() {
    const {
      menuOpened,
      headerScrolled,
      headerHidden,
    } = this.state;
    classNames(this.element, { 'header--menu-opened': menuOpened });
    classNames(this.element, { 'header--scrolled': headerScrolled });
    classNames(this.element, { 'header--hidden': headerHidden });
    classNames(document.body, { 'overflow-full': menuOpened });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Header.js